import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahod5roh653ivfvo2hg";

const focusOptions = ["全部更新", "事件线为主", "回应合集为主", "早年旧瓜补课"];

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honey = String(formData.get("website_alt") || "").trim();
    if (honey) {
      setStatus("success");
      setErrorMsg("");
      form.reset();
      return;
    }
    formData.delete("website_alt");

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, String(value));
    });

    setStatus("loading");
    setErrorMsg("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setErrorMsg(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setErrorMsg("网络异常，暂时没能提交，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="bg-secondary-100 border border-secondary-200 rounded-lg px-5 md:px-10 py-8 md:py-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-5">
              <span className="text-xs tracking-[0.3em] text-secondary-700 uppercase">
                Subscribe
              </span>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                归档更新提醒
              </h2>
              <p className="mt-3 text-sm md:text-base leading-7 text-foreground-700">
                新的历史记录和往期合集会定期打包更新。留个邮箱，有新的补课内容时我们提醒你一声，不用天天来刷。
              </p>
            </div>

            <div className="lg:col-span-7">
              <form
                data-readdy-form
                id="archive-subscribe-form"
                onSubmit={handleSubmit}
                className="flex flex-col gap-3"
              >
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="你的邮箱地址"
                    className="flex-1 h-12 px-4 rounded-md border border-secondary-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400"
                  />
                  <select
                    name="focus"
                    defaultValue={focusOptions[0]}
                    className="h-12 px-4 rounded-md border border-secondary-300 bg-background-50 text-sm text-foreground-900 outline-none focus:border-primary-400 cursor-pointer"
                  >
                    {focusOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="archive-alt-field"
                />

                <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                  <button
                    type="submit"
                    disabled={status === "loading"}
                    className="h-12 px-8 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {status === "loading" ? "提交中…" : "订阅归档更新"}
                  </button>
                  <span className="text-xs text-foreground-600">
                    只发送归档更新，不会分享给其他人。
                  </span>
                </div>

                {status === "success" && (
                  <p className="inline-flex items-center gap-2 text-sm text-secondary-800">
                    <i className="ri-check-line text-primary-600" />
                    订阅成功，有新的归档更新会通知你。
                  </p>
                )}
                {status === "error" && (
                  <p className="inline-flex items-center gap-2 text-sm text-primary-700">
                    <i className="ri-error-warning-line" />
                    {errorMsg}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}